module.exports = __webpack_public_path__ + "img/zuniLogo.9e6c0f33.svg";